import { getCustomerConversation } from '~/selectors';
import { ChannelType, ContentTypes, MessageStatus } from '~/constants';

export const setMessages =
  (conversationID, payload) => (dispatch, getState) => {
    const state = getState();

    const stateMessages = state[`conversation_${conversationID}`]?.messages;

    if (stateMessages === undefined) {
      return;
    }

    const mergedMessages = [...stateMessages];
    const { messages, agents, limit, offset, total } = payload;

    const agentsMap = new Map();

    agents.forEach(({ id, provider, channel_type }) =>
      agentsMap.set(id, { provider, channel: channel_type })
    );

    const { messagesSearch } = state.conversations;
    let hasUpdatedFile = false;

    messages.forEach((message) => {
      const fitSearch = message?.payload?.text
        ?.toLowerCase()
        .includes(messagesSearch);

      if (messagesSearch && !fitSearch) {
        return;
      }

      const agent = agentsMap.get(message.agent_id);
      const provider = agent?.provider ?? null;
      const channel = agent?.channel ?? null;

      const index = mergedMessages.findIndex(
        (existedMessage) => existedMessage.id === message.id
      );

      if (index === -1) {
        mergedMessages.push({ ...message, provider, channel });
      } else {
        const isEcho = channel === ChannelType.ECHO;
        let isOldMessageSuitableForPostUpload;
        let isNewMessageSuitableForPostUpload;

        if (isEcho) {
          isOldMessageSuitableForPostUpload =
            mergedMessages[index].payload?.category ===
            ContentTypes.UNSPECIFIED;
          isNewMessageSuitableForPostUpload =
            message.payload?.category !== ContentTypes.UNSPECIFIED;
        } else {
          isOldMessageSuitableForPostUpload =
            mergedMessages[index].status === MessageStatus.CREATED;
          isNewMessageSuitableForPostUpload =
            message.status !== MessageStatus.CREATED;
        }

        hasUpdatedFile =
          isOldMessageSuitableForPostUpload &&
          isNewMessageSuitableForPostUpload;

        mergedMessages[index] = {
          ...message,
          provider,
          channel,
        };
      }
    });

    dispatch({
      type: `chats/${conversationID}/SET_MESSAGES`,
      payload: {
        messages: mergedMessages,
        count: mergedMessages.length,
        limit,
        offset,
        total,
        hasUpdatedFile,
      },
    });
  };

export const deleteMessages =
  (conversationID, messagesIDs) => (dispatch, getState) => {
    const state = getState();

    const conversationState = getCustomerConversation(conversationID)(state);

    if (conversationState?.messages === undefined) {
      return;
    }

    const stateMessages = [...conversationState?.messages];

    const newMessages = stateMessages.filter(
      (message) => !messagesIDs.includes(message.id)
    );

    const removedMessagesCount = stateMessages.length - newMessages.length;

    if (removedMessagesCount === 0) {
      return;
    }

    dispatch({
      type: `chats/${conversationID}/SET_MESSAGES`,
      payload: {
        messages: newMessages,
        count: conversationState.count - removedMessagesCount,
        limit: conversationState.limit,
        offset: conversationState.offset,
        total: conversationState.total - removedMessagesCount,
        hasUpdatedFile: false,
      },
    });
  };
